<shared-breadcrumbs [ComponentData]="BreadcrumbsData"></shared-breadcrumbs>

<div class="pg-content__inner">
  <div *ngIf="NewsDetailData | async as NewsDetail">
    <div class="pg-wrapper news-detail__wrapper">
      <shared-news-item [NewsView]="NVType.Detail" [NewsItem]="NewsDetail"></shared-news-item>
    </div>
  </div>
</div>
